import base from '../dr-base'
import drFileViewer from './dr-file-viewer.vue'

const schema = {
  $Type: 'dr-file-viewer',
  name: 'File viewer',
  group: 'Advanced',
  icon: 'file-search',
  ...base,
  properties: {
    ...base.properties,
    /*
    ** { type: 'pdf', name: 'myFile', 'https://myFile.pdf' }
    */
    FileSource: {
      name: 'vuetifyWidgets.dr-file-viewer.fileSource',
      type: 'string',
      default: '',
      HintText: 'vuetifyWidgets.dr-file-viewer.fileDataFormat'
    },
    // формат: 300px
    Width: {
      name: 'vuetifyWidgets.dr-file-viewer.width',
      type: 'string'
    },
    // формат: 300px
    Height: {
      name: 'vuetifyWidgets.dr-file-viewer.height',
      type: 'string'
    }
  }
}

export default {
  schema,
  component: drFileViewer
}
